import React from "react"

export default class CitiesAll extends React.Component 
{  
    constructor(props)
    {
        super(props);
        this.state = {
            wasClicked: false,
        } 
        this.env = this.props.env;
        this.cities = this.props.cities.length > 0 ? this.props.cities : [];
        this.letters = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
        this.place = this.props.state;         
        this.code = this.props.code;
        this.codes = this.props.codes;
        this.cities.sort((a,b) => (a.place > b.place) ? 1 : ((b.place > a.place) ? -1 : 0));
    } 

    pickTitle = () =>
    {
        let title = 'More Places for {state} {keyword_group_name}';
        let keyword_group_name = '';

        title = title.replace('{state}', this.place.name);

        this.codes.map(code =>
        {
            if(code.code === this.code)
            {
                keyword_group_name = code.name; 
            }          
        })
        
        title = title.replace('{keyword_group_name}', keyword_group_name);
       
        return title;
    }

    show = (letter) =>
    {        
        if (typeof window !== 'undefined') 
        {           
            const cities = document.getElementsByClassName('letter-'+letter);

            for (let city of cities) 
            {
                const classes = city.className+' show';                        
                city.className = classes;
            }     
        }
    }

    hide = () =>
    {        
        if (typeof window !== 'undefined') 
        { 
            const allcities = document.getElementsByClassName('letter-city');
            
            for (let city of allcities) 
            {
                const classes = city.className.replace(' show','');
                city.className = classes;
            }
        }
    }

    changeTo = (letter) =>
    {
        this.setState({ wasClicked: true });    
        this.hide();
        this.show(letter);
    }

    breadcrumb = () =>
    {
        let keyword_group_name = '';
        let keyword_group_url = '';
        let keyword_group_state_url = '';
        let state_url = '';

        this.codes.map(code =>
        {
            if(code.code === this.code)
            {
                keyword_group_name = code.name;
                keyword_group_url = '/'+code.paths.code;
                keyword_group_state_url = keyword_group_url; 

                switch (this.place.slug) 
                {
                    case 'district-of-columbia':							
                    state_url = `/district-of-columbia/${code.code}-district-of-columbia-dc`;
                        break;
                
                    default:

                        switch (code.code) 
                        {
                            case 'dumpster': case 'demolition-contractors':
                                state_url = `/${this.place.slug}/index.html`;
                                break;
                            case 'comercial-trash-service':
                                state_url = `/${this.place.slug}/commercial-waste-management/index.html`;
                                break;
                            default:
                                state_url = `/${this.place.slug}/${code.code}/index.html`;
                            break;
                        }

                        break;
                }                 
            }          
        })
        
        return(

            <ul>
                <li><a href="/">Home</a></li>
                <li>{'>'}</li>
                <li><a href={keyword_group_url}>{keyword_group_name}</a></li>
                <li>{'>'}</li>
                <li><a href={state_url}>{this.place.av}</a></li>
                <li>{'>'}</li>
                <li>More Places</li>
            </ul>
        )
    }

    render()
    {        
        return(

            <section className="section cities-all">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="allcities-breadcrumb">{this.breadcrumb()}</div>
                            <h1>{this.pickTitle()}</h1>
                        </div>
                    </div>
                    <ul className="all-cities">
                    {                       
                        this.cities.map((city, index) => 
                        {                           
                            const first_letter = city.place.charAt(0);
                            let classes = 'letter-city letter-'+first_letter;
                            if(!this.state.wasClicked && first_letter === 'A') classes = classes + ' show';
                            const name = city.place.split(',')
                            
                            return (
                                <li key={index} className={classes}>
                                    <a href={'/'+city.url}>{name[0]}</a>
                                </li>
                            )
                        })
                    }
                    </ul>

                    <ul className="all-letters row">
                    { 
                        this.letters.map((letter) => 
                        {                           
                            return (
                                <>
                                <li><a href="#" onClick={() => { this.changeTo(letter) }}>{letter}</a></li>
                                <li className="line">|</li>
                                </>
                            )
                        })
                    }
                    </ul>
                </div>
            </section>

        )
    }
}